/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { Body1, Subtitle2Stronger } from "../../packages/fluent9";
import { Grid } from "../grid";
import { GridItem } from "../gridItem";

import { useStyles } from "./ErrorPage.styles";
import { ErrorPageProps } from "./ErrorPageProps";

/**
 * Renders the Cross-Location open shifts experience.
 * @param props The properties.
 * @returns The Cross-Location open shifts experience.
 */
export const ErrorPage: React.FC<ErrorPageProps> = props => {
    const { icon, message, title } = props;
    const styles = useStyles();

    return (
        <Grid className={styles.grid}>
            <GridItem className={styles.left}>
                <Subtitle2Stronger>{title}</Subtitle2Stronger>
                <br />
                <Body1>{message}</Body1>
            </GridItem>
            <GridItem className={styles.right}>{icon}</GridItem>
        </Grid>
    );
};
